<div *ngIf="shouldDisplay" class="warning-container">
  <mat-icon>warning</mat-icon>
  <div class="warning-message-container">
    <p class="warning-title">{{ title }}</p>
    <p class="warning-message">{{ message }}</p>
  </div>
</div>
